import {h} from 'preact';
import {
	getCurrentScreenMode,
	ScreenMode,
} from '~/app/utils/Screen';
import fetchVisualOverview from './asyncActions/fetchVisualOverview';
import MobileVisual from './MobileVisual';
import MobileVisualVertical from './MobileVisualVertical';
import {/* dispatch, */SubscribedComponent} from './Store/index';
import State from './Store/State';
import Visual from './Visual';

/**
 * Максимальное отношение ширины к высоте экрана.
 */
// const MAX_RATIO = 2;

/**
 * Component Properties.
 */
interface RootVisualProps
{
	[key: string]: void;
}

/**
 * Component State.
 */
interface RootVisualState
{
	/** Изображение общего экрана */
	overviewImage: string;
	/** Мобильный режим? */
	mobileMode: boolean;
	/** Вертикальный мобильный режим? */
	verticalMode: boolean;
}

/**
 * Корень визуального режима.
 */
class RootVisual extends SubscribedComponent<State, RootVisualProps, RootVisualState>
{
	/**
	 * Корень визуального режима.
	 */
	public constructor( props: RootVisualProps )
	{
		super( props );
		
		this.state = {
			overviewImage: '',
			mobileMode: false,
			verticalMode: false,
		};
	}
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		window.addEventListener( 'resize', this.onWindowResize );
		this.onWindowResize();
		
		if ( this.state.overviewImage === '' )
		{
			fetchVisualOverview( 'front' );
		}
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		window.removeEventListener( 'resize', this.onWindowResize );
	}
	
	/**
	 * Render component.
	 */
	public render(
		_props: RootVisualProps,
		{mobileMode, verticalMode, overviewImage}: RootVisualState,
	): JSX.Element
	{
		return (
			mobileMode
			? (
				verticalMode
				? <MobileVisualVertical
					background={overviewImage}
				/>
				: (
					<MobileVisual />
				)
			)
			: (
				<Visual />
			)
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{visualData: {overview: {image}}}: State,
	): void
	{
		if ( image === this.state.overviewImage )
		{
			return;
		}
		
		this.setState( {overviewImage: image} );
	}
	
	/**
	 * При изменении размеров окна.
	 */
	private onWindowResize = (): void =>
	{
		const {mobileMode, verticalMode} = this.state;
		const ratio = window.innerWidth / window.innerHeight;
		const vertical = ( ratio < 1 );
		
		if ( verticalMode !== vertical )
		{
			this.setState( {verticalMode: vertical} );
		}
		
		const mobile = ( getCurrentScreenMode() < ScreenMode.NOTEBOOK );
		
		if ( mobileMode !== mobile )
		{
			this.setState( {mobileMode: mobile} );
		}
	}
}

/**
 * Module.
 */
export {
	RootVisual as default,
	RootVisualProps,
	RootVisualState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/RootVisual.tsx